module.exports = __webpack_public_path__ + "img/information-circle-green-1.a2d8ec80.svg";